import { useMemo, useEffect } from "react"
import { CalculationSchema } from "src/features/calculator/schema"
import { UseFormSetValue } from "react-hook-form"

type Calculation = {
  customerTransferFeeRate: number // 送客手数料率(税込)
  totalReimbursement: number // 立替元本
  selfPayment: number // 自己負担額
  customerTransferFee: number // 送客手数料(税込)
  remittance: number // 立替金送金額
  exCustomerTransferFeeRate?: number // 送客手数料率(税抜)
}

type Props = {
  values: CalculationSchema
  setValue: UseFormSetValue<CalculationSchema>
  calculation: Calculation
}

export function useCalculatedResult({ values, setValue, calculation }: Props): Calculation {
  const {
    exCustomerTransferFeeRate,
    consumptionTaxRate,
    maxAdvancePayment,
    initialCost,
    downPayment,
    rent,
    customerTransferFeeRate,
    totalReimbursement,
    customerTransferFee,
    monthlyTransferCount,
    exDiscountedCustomerTransferFeeRate,
  } = values

  const calculatedResult: Calculation = useMemo(() => {
    return calculation
  }, [
    exCustomerTransferFeeRate,
    consumptionTaxRate,
    maxAdvancePayment,
    initialCost,
    downPayment,
    rent,
    customerTransferFeeRate,
    totalReimbursement,
    customerTransferFee,
    monthlyTransferCount,
    exDiscountedCustomerTransferFeeRate,
  ])

  useEffect(() => {
    setValue("customerTransferFeeRateResult", calculatedResult.customerTransferFeeRate)
    setValue("totalReimbursementResult", calculatedResult.totalReimbursement)
    setValue("selfPaymentResult", calculatedResult.selfPayment)
    setValue("customerTransferFeeResult", calculatedResult.customerTransferFee)
    setValue("remittanceResult", calculatedResult.remittance)
    setValue("exCustomerTransferFeeRateResult", calculatedResult.exCustomerTransferFeeRate)
  }, [calculatedResult, setValue])

  return calculatedResult
}
